import { render, staticRenderFns } from "./PlotValuation.vue?vue&type=template&id=bb1afd10&scoped=true&"
import script from "./PlotValuation.vue?vue&type=script&lang=js&"
export * from "./PlotValuation.vue?vue&type=script&lang=js&"
import style0 from "./PlotValuation.vue?vue&type=style&index=0&id=bb1afd10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1afd10",
  null
  
)

export default component.exports